import React, { Fragment } from "react";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import Reflection from "../../components/Reflection/Reflection";

export default function StudentReflection() {
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer" style={{ paddingBottom: "0" }}>
          <div className="app-main__inner" style={{ padding: "0" }}>
            <div className="reflection-page">
              <Reflection />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
